<payee-popup [title]="dialogData?.transition_label">
  <ng-template #payeePopupTitleTemplate>
    <h1 class="title">{{ dialogData?.transition_label }}</h1>
  </ng-template>

  <ng-template #payeePopupDescriptionTemplate>
    <div class="description">
      {{ "WORKFLOW_DIALOGS.HARD_LEGALLY_BINDING.DESCRIPTION" | translate }}
    </div>
  </ng-template>

  <div class="dialog-content">
    <form [formGroup]="form">
      @if (dialogData) {
        <payee-radio-group
          vertical
          [formControl]="enforceableOption"
          [options]="dialogData.options"
          [displayWith]="displayWith"
        ></payee-radio-group>
      }

      @if (enforceableOption.dirty) {
        @if (enforceableOption.hasError("required")) {
          <mat-error>
            {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
          </mat-error>
        }
      }

      <payee-form-field
        width="max"
        height="taller"
      >
        <textarea
          payee-input
          placeholder="Fejtsd ki részletesen..."
          formControlName="message"
        ></textarea>

        @if (message.dirty) {
          @if (message.hasError("required")) {
            <mat-error>
              {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
            </mat-error>
          }
        }
      </payee-form-field>

      <payee-workflow-provided-media [transitionWithDialog]="data"></payee-workflow-provided-media>

      <div class="subtitle">Fájlok feltöltése</div>

      <payee-form-field width="max">
        <payee-dropzone
          width="max"
          [title]="dropzoneTitle"
          [isDisabled]="files.disabled"
          (dropped)="onDrop($event)"
        ></payee-dropzone>
        @if (files.invalid && files.touched) {
          <span payee-error>Kérünk, tölts fel legalább egy fájlt.</span>
        }
      </payee-form-field>

      <div class="files-list">
        @for (file of files.value; track $index; let fileIndex = $index) {
          @if (file) {
            <div class="file-item flex vcenter">
              <div class="file-status">
                <payee-icon name="checkmark-darker-green-circle"></payee-icon>
              </div>
              <div class="file-name">{{ file.name }}</div>
              <button
                payee-icon-button
                color="white"
                class="file-delete-button"
                (click)="removeFile(fileIndex)"
              >
                <payee-icon name="trash-red"></payee-icon>
              </button>
            </div>
          }
        }
      </div>
    </form>
  </div>

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      [disabled]="loading"
      [loading]="loading"
      (click)="submit()"
    >
      Rögzítés
    </button>
  </ng-template>

  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      color="white"
      width="max"
      [isBorderButton]="true"
      (click)="cancel()"
    >
      Mégsem
    </button>
  </ng-template>
</payee-popup>
